import { useMutation, useQueryClient } from 'react-query';
import { EStatementPreferencesDTO } from './useEStatementPreferencesQuery';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

const eStatementPreferences = ({ clientId }) => (params: EStatementPreferencesDTO) => {
  return authFetch(
    urlWithParams('/Consumer/EStatementSettings', {
      clientId,
    }),
    { method: 'PUT', ...httpBodyOptions(params, true) },
  );
};

export const useEStatementPreferencesMutation = () => {
  const { clientId } = useRouteParams();
  const queryClient = useQueryClient();

  return useMutation(eStatementPreferences({ clientId }), {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.eStatementPreferences(clientId));
    },
  });
};
